import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=1c30d4ed&scoped=true&"
import script from "./Roles.vue?vue&type=script&lang=js&"
export * from "./Roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30d4ed",
  null
  
)

component.options.__file = "Roles.vue"
export default component.exports